const POST_AUTH_REDIRECT_KEY = 'okio_post_auth_redirect';

const isValidRedirectTarget = (target) => {
  if (!target || typeof target !== 'string') return false;
  if (!target.startsWith('/')) return false;
  if (target.startsWith('//')) return false;
  if (target === '/' || target.startsWith('/login') || target.startsWith('/register')) {
    return false;
  }
  return true;
};

export const locationToRedirectTarget = (location) => {
  if (!location?.pathname) return null;
  const target = `${location.pathname}${location.search || ''}${location.hash || ''}`;
  return isValidRedirectTarget(target) ? target : null;
};

export const persistPostAuthRedirect = (target) => {
  if (!isValidRedirectTarget(target)) return;
  sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, target);
};

export const persistPostAuthRedirectFromLocation = (location) => {
  const target = locationToRedirectTarget(location);
  if (target) {
    persistPostAuthRedirect(target);
  }
};

export const getStoredPostAuthRedirect = () => {
  const target = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  return isValidRedirectTarget(target) ? target : null;
};

export const clearStoredPostAuthRedirect = () => {
  sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
};

export const hasExplicitPostAuthIntent = (location) => {
  return Boolean(locationToRedirectTarget(location?.state?.from));
};

export const consumePostAuthRedirect = (fallback = '/new', shouldUseTarget) => {
  const storedTarget = getStoredPostAuthRedirect();
  if (storedTarget) {
    clearStoredPostAuthRedirect();
    if (!shouldUseTarget || shouldUseTarget(storedTarget)) {
      return storedTarget;
    }
  }
  return fallback;
};

export const getAuthDestination = (location, fallback = '/new') => {
  const fromTarget = locationToRedirectTarget(location?.state?.from);
  if (fromTarget) {
    persistPostAuthRedirect(fromTarget);
    return fromTarget;
  }

  return getStoredPostAuthRedirect() || fallback;
};
